// import 'nodelist-foreach-polyfill';
import 'lazyload';
lazyload();

$(document).ajaxSuccess(function(event, xhr, settings ) {
  lazyload();
});
